import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, AlertTriangle, Loader2 } from "lucide-react";
import { api } from "../lib/api";

export default function VerifyEmail() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [state, setState] = useState("loading"); // loading | ok | error
    const [message, setMessage] = useState("");

    useEffect(() => {
        if (!token) { setState("error"); setMessage("Missing token."); return; }
        api.post("/auth/verify-email", { token })
            .then(() => { setState("ok"); setMessage("Email verified — you're all set."); })
            .catch((e) => { setState("error"); setMessage(e.response?.data?.detail || "Verification failed."); });
    }, [token]);

    return (
        <div className="min-h-screen grid place-items-center p-6" data-testid="verify-email-page">
            <div className="card-warm p-8 max-w-md w-full text-center">
                <div className="font-script text-xl text-[var(--brand-orange)] mb-1">virtually</div>
                <div className="font-serif text-2xl mb-5">Email verification</div>
                {state === "loading" && (
                    <div className="flex flex-col items-center gap-2">
                        <Loader2 size={28} className="animate-spin text-[var(--brand-purple)]" />
                        <div className="text-sm text-[var(--text-ink)]/65">Verifying your email…</div>
                    </div>
                )}
                {state === "ok" && (
                    <div className="flex flex-col items-center gap-3">
                        <CheckCircle2 size={36} className="text-[var(--status-green)]" />
                        <div className="text-sm">{message}</div>
                        <Link to="/dashboard" data-testid="verify-go-dashboard" className="btn-primary text-sm">
                            Go to dashboard
                        </Link>
                    </div>
                )}
                {state === "error" && (
                    <div className="flex flex-col items-center gap-3">
                        <AlertTriangle size={36} className="text-[var(--brand-magenta)]" />
                        <div className="text-sm">{message}</div>
                        <Link to="/login" data-testid="verify-go-login" className="btn-ghost text-sm">
                            Back to login
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
}
